import styles from './StudentDiscountMessageBlock.module.scss';
import { GraduationCap } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';

export const StudentDiscountMessageBlock = () => {
  return (
    <div className={styles.root}>
      <GraduationCap size={SVG_SIZE_M} />
      <span>
        Students save 50% on individual monthly plans for the next 6 months.
        Discount applied at checkout.
      </span>
    </div>
  );
};
